var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.121,
    height: 18.121,
    viewBox: "0 0 18.121 18.121",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4321",
    transform: "translate(-481.439 -518.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mic-alt",
    d: "M6.75,1.5A2.25,2.25,0,0,0,4.5,3.75v4.5a2.25,2.25,0,1,0,4.5,0V3.75A2.25,2.25,0,0,0,6.75,1.5Zm0-1.5A3.75,3.75,0,0,1,10.5,3.75v4.5a3.75,3.75,0,1,1-7.5,0V3.75A3.75,3.75,0,0,1,6.75,0ZM0,8.273a.75.75,0,0,1,1.5,0A5.228,5.228,0,0,0,6.728,13.5h.045A5.227,5.227,0,0,0,12,8.273a.75.75,0,1,1,1.5,0A6.727,6.727,0,0,1,6.773,15H6.727A6.727,6.727,0,0,1,0,8.273Z",
    transform: "translate(484 520)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_233",
    y1: 16,
    x2: 16,
    transform: "translate(482.5 519.5)",
    fill: "none",
    stroke: "#dc2e2e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mic-off.4951de06a7928a0c3ae005582b37a127.svg";